import CardsDetailsPage from "./CardsDetailsPage";

export default CardsDetailsPage;
